import React from 'react'
import { useTranslation } from 'react-i18next'
import { DocumentState } from 'types/enums'

import IconValidated from './Icons/Validated'
import IconPending from './Icons/Pending'
import IconInvalidated from './Icons/Invalidated'
import IconAttached from './Icons/Attached'

const Document: React.FC<{ state: DocumentState | undefined }> = ({
  state,
}) => {
  const { t } = useTranslation(['assignments'])
  const icon = (documentState: DocumentState | undefined) => {
    switch (documentState) {
      case DocumentState.Attached: {
        return <IconAttached />
      }
      case DocumentState.Invalidated: {
        return <IconInvalidated />
      }
      case DocumentState.Pending: {
        return <IconPending />
      }
      case DocumentState.Validated: {
        return <IconValidated />
      }
      case undefined:
      default: {
        return <IconPending />
      }
    }
  }

  return (
    <>
      {t(`card.loan-info.${state}`)} {icon(state)}
    </>
  )
}

export { Document }
